export default {
  reports: {
    // ---- AI report error codes (backend `errorCode`) -> localized messages ----
    errors: {
      INSUFFICIENT_CREDITS:
        "Huna krediti za AI za kutosha kutengeneza ripoti hii. Tafadhali wasiliana na msimamizi wako.",
      REPORT_ACCESS_DENIED: "Ripoti hii ya AI haijawashwa kwa akaunti yako.",
      NOT_FOUND: "Ripoti iliyoombwa haikupatikana.",
      INVALID_INPUT: "Baadhi ya maelezo uliyotoa si sahihi. Tafadhali yakague na ujaribu tena.",
      INVALID_GEOMETRY: "Eneo ulilochagua si sahihi. Tafadhali rekebisha geofence na ujaribu tena.",
    },
    male: "Mwanaume",
    female: "Mwanamke",
    other: "Nyingine",
    farmerName: "Jina la Mkulima",
    farmerProdChart: "Chati ya Uzalishaji wa Mkulima",
    production: "Uzalishaji",
    byProduction: "Kwa Uzalishaji",
    byName: "Kwa Jina",
    descending: "Kushuka",
    ascending: "Kupanda",
    buyingStationProdChart: "Chati ya Uzalishaji wa Kituo cha Kununua",
    buyingStation: "Kituo cha Kununua",
    buyingStationName: "Kununua Jina la Kituo",
    dryMilling: "Kusaga Kavu",
    dryMillingName: "Jina la Dry Milling",
    dryMillingProdChart: "Chati ya Uzalishaji wa Usagishaji Vikavu",
    view: "Tazama",
    date: "Tarehe",
    reports: "Ripoti",
    today: "Leo",
    week: "Wiki",
    month: "Mwezi",
    year: "Mwaka",
    all: "Zote",
    selectCrop: "Chagua Mazao",
    selectRegion: "Chagua Mkoa",
    selectProvinceState: "Chagua Mkoa/Jimbo",
    downloadPdfReport: "Pakua Ripoti ya PDF",
    export: "Eksport",
    search: "Tafuta",
    yield: "Mazao",
    averageSellingPriceByAllFarmers: "Bei ya Kuuza kwa Wakulima Wote",
    averageSellingPricePerFarmer: "Bei ya Kuuza kwa Mkulima Mmoja",
    pricePaid: "Bei Iliyolipwa",
    pests: {
      pestReport: "Ripoti ya Wadudu Wabovu",
      filterByCrops: "Chuja Kwa Mazao",
      pestStatistics: "Takwimu za Wadudu Wabovu",
      regions: "Mikoa",
      occurrences: "Matukio",
      pestChart: "Grafu ya Wadudu Wabovu",
      totalArea: "Jumla ya Eneo",
      pestName: "Jina la Wadudu Wabovu",
      region: "Mkoa",
      crop: "Mazao",
      listByLand: "Orodha Kwa Ardhi",
    },
    regions: {
      regionalReport: "Ripoti ya Kikanda",
      listByFarm: "Orodha kwa Shamba",
      listByFarmers: "Orodha kwa Wakulima",
      listByYield: "Orodha kwa Mazao",
      regionalStatistics: "Takwimu za Kikanda",
      countries: "Nchi",
      states: "Mikoa/Majimbo",
      city: "Mji/Kijiji",
      farmsIn: "Mashamba huko",
      regionalChart: "Grafu ya Kikanda",
      farms: "Mashamba",
      regionName: "Jina la Kanda",
      farmers: "Wakulima",
      yield: "Mazao/Eka",
    },
    dashboard: {
      topCharts: "Majedwali ya Juu",
      regions: "Mikoa",
      noOfFarms: "Idadi ya Mashamba/Kanda",
      provinces: "Mikoa",
      landArea: "Eneo la Ardhi",
      avgFarmerLand: "Eneo la Mkulima Wastani",
      viewAll: "Tazama Yote",
      crops: "Mazao",
      plantedAreaCrop: "Eneo Lililopandwa/Kilimo",
      plantedArea: "Eneo Lililopandwa",
      avgYieldCrop: "Mavuno Wastani/Kilimo",
      averageYield: "Mavuno Wastani",
      yieldChart: "Grafu ya Mavuno",
      selectFarm: "Chagua Shamba",
      soilQuality: "Ubora wa Udongo",
      pests: "Wadudu",
      occurrences: "Matukio",
      equipments: "Vifaa",
      goalAchievedChart: "Chati ya Malengo Yaliyofikiwa",
      soilValues: "Maadili ya Udongo",
      soil: "Maadili",
      showReport: "Onyesha ripoti kwenye Dashibodi",
      selectAll: "Chagua zote",
    },
    avgPrice: "Bei ya Wastani",
    avgPriceFarmer: "Bei ya Wastani Inayolipwa kwa Mkulima (Kakao)",
    byCountry: "Kwa Nchi",
    gen: "Jinsia",
    gender: "Chatu ya Jinsia",
    selectYear: "Chagua Mwaka",
    total: "Jumla",
    unspefied: "Haijabainishwa",
    weight: "Uzito",
    quality: "Ubora",
    price: "Bei",

    yieldPrediction: "Utabiri wa Mavuno",
    listOfReports: "Orodha ya Ripoti",
    noYieldPredictionReportsFound: "Hakuna ripoti za utabiri wa mavuno zilizopatikana",
    loadingYieldPredictions: "Inapakia utabiri wa mavuno...",
    createNewReport: "Unda Ripoti Mpya",

    howToUseReport: "Jinsi ya kutumia Ripoti?",
    viewGuide: "Tazama Mwongozo",
    cancel: "Ghairi",
    generateReport: "Tengeneza Ripoti",
    selectFarmGeofence: "Chagua Geofence ya Shamba",
    selectFarmGeofenceDescription: "Chagua shamba lililosajiliwa, chora mpaka wa shamba lako kwenye ramani, au ingiza eneo ili kuanza kuchanganua utabiri wa mavuno wa eneo la shamba.",
    point: "Nukta",
    geofence: "Geofence",
    selectFarmZone: "Chagua Shamba/Kanda",
    select: "Chagua",
    latitude: "Latitudo",
    longitude: "Longitudo",
    uploadGeojsonFile: "Pakia Faili la GeoJSON",
    uploadGeojsonFileDescription: "Chagua faili la GeoJSON lenye geofence yako kutoka kwa kompyuta yako na uipakie. Geofence moja tu itapakiwa kwa wakati mmoja, hata kama faili lako lina geofence nyingi.",
    selectAFile: "Chagua Faili",
    hideAdvanced: "Ficha Hali ya Juu",
    showAdvancedVariation: "Onyesha Tofauti za Juu",
    uploadHistoricalYieldDataDescription: "Tafadhali pakia data ya mavuno ya kihistoria ya shamba lako",
    showInstructions: "Onyesha Maelekezo",
    downloadTemplate: "Pakua Kiolezo",
    chooseFile: "Chagua Faili",
    noFileSelected: "Hakuna faili lililochaguliwa",
    yieldPredictionGuide: "Mwongozo wa Utabiri wa Mavuno",
    forecastedYields: "Mavuno Yaliyotabiriwa",
    farmArea: "Eneo la Shamba",
    yieldForecasts: "Utabiri wa Mavuno",
    graph: "Grafu",
    actualYields: "Mavuno Halisi",
    predictedFutureYields: "Mavuno ya Baadaye Yaliyotabiriwa",
    averageYields: "Mavuno ya Wastani",
    yieldTrendsGraph: "Grafu ya Mwelekeo wa Mavuno",
    step1: "Hatua 1",
    step2: "Hatua 2",
    step3: "Hatua 3",
    step4: "Hatua 4",
    satelliteMapView: "Mwonekano wa Ramani ya Setelaiti",
    selectYourFarm: "Chagua shamba lako kutoka kwenye menyu kunjuzi (kama tayari limesajiliwa).",
    selectCropType: "Chagua aina ya mazao:",
    clickGenerateReport: "Bofya 'Tengeneza Ripoti' kuona ripoti yako ya utabiri wa mavuno.",
    howToGenerateReport: "Jinsi ya Kutengeneza Ripoti?",
    howToInterpretReport: "Jinsi ya Kufafanua Ripoti?",
    tip: "Kidokezo",

    disclaimer: "Kanusho",
    disclaimer1: "Haiwezekani kutabiri hali ya hewa kwa usahihi kwa msimu mzima. Kwa mfano, mvua ya mawe au mafuriko yanaweza kutokea wakati wowote, ambayo yanaweza kuathiri kwa kiasi kikubwa utabiri wa mavuno.",
    disclaimer2: "Mavuno yanategemea sana mbinu za usimamizi wa mkulima. Kwa mfano, matumizi ya dawa za wadudu kwa wakati unaofaa au umwagiliaji sahihi unaweza kuathiri sana mavuno ya mwisho.",
    disclaimer3: "Kuna mambo mengine ambayo yanaweza kuchangia makosa makubwa katika utabiri wa mavuno wa AI.",
    startYear: "Mwaka wa Mwanzo",
    endYear: "Mwaka wa Mwisho",
    back: "Rudi",
    deleteReport: "Futa Ripoti",
    confirmDeleteReport: "Una uhakika unataka kufuta ripoti hii ya utabiri wa mavuno? Kitendo hiki hakiwezi kutenduliwa na data zote zinazohusiana zitafutwa kabisa.",
    deleteConfirmation: "Uthibitisho wa Kufuta",
    download: "Pakua",
    report: "Ripoti",
    dateOfReport: "Tarehe ya Ripoti",
    farm: "Shamba",
    location: "Mahali",
    zone: "Kanda",
    crop: "Mazao",
    farmers: "Wakulima",
    yieldPerAcre: "Mavuno/Eka",
    yieldPerHectare: "Mavuno/Hekta",
    predictionModel: "Modeli ya Utabiri",
    accuracy: "Usahihi (R²)",
    confidence: "Imani",
    producer: "Mzalishaji",
    reportDeletedSuccessfully: "Ripoti imefutwa kwa mafanikio",
    failedToDeleteReport: "Imeshindwa kufuta ripoti",
    enterHere: "Ingiza hapa",
    hectares: "hekta",
    whatIsYieldReportTitle: "Ripoti ya Utabiri wa Mavuno ni nini?",
    yieldReportDescription: "Ripoti ya Utabiri wa Mavuno inakusaidia kukadiria mavuno ya mazao kwa shamba lako kwa kutumia data ya kihistoria, data ya setelaiti, na mifano ya utabiri inayotegemea AI. Ripoti inakupa makadirio ya kiasi cha mavuno unayoweza kuvuna katika mwaka huu na ujao. Ripoti hutoa ufahamu kuhusu mavuno halisi, mavuno ya baadaye yaliyotabiriwa, na mavuno ya wastani, ikikuwezesha kuboresha shughuli zako za kilimo na kupanga mbele.",
    creatingYourReportEasy: "Kuunda ripoti yako ni rahisi:",
    selectYourFarmDescription: "Mpaka utaonekana kwenye ramani. Au, chora mpaka wa shamba lako (poligoni au nukta) mwenyewe kwenye ramani kama bado halijasajiliwa. Unaweza pia kutafuta kwa kuandika Latitudo na Longitudo ili kukuza eneo.",
    selectCropTypeDescription: "Chagua mazao unayotaka kuchanganua kutoka kwenye menyu kunjuzi.",
    clickGenerateReportDescription: "kuona ripoti yako ya utabiri wa mavuno.",
    interpretReportIntro: "Baada ya ripoti kutengenezwa, utaona utabiri wa mavuno kwa mwaka wa sasa na ujao. Grafu inaonyesha mwelekeo wa mavuno wa shamba lako kwa mistari mitatu:",
    blueLineActualYields: "Mstari wa Bluu (Mavuno Halisi):",
    blueLineDescription: "Inawakilisha matokeo halisi ya mavuno kutoka misimu iliyopita kwenye shamba lako. Hii inakusaidia kuelewa mwenendo wa utendaji wa zamani kwa muda.",
    redLinePredictedYields: "Mstari Mwekundu (Mavuno ya Baadaye Yaliyotabiriwa):",
    redLineDescription: "Inaonyesha utabiri unaotegemea AI kwa mavuno yajayo. Inatoa makadirio ya unayoyatarajia (kiasi gani unaweza kuvuna) kulingana na data na mienendo ya sasa.",
    brownLineAverageYields: "Mstari wa Kahawia (Mavuno ya Wastani):",
    brownLineDescription: "Inaonyesha mavuno ya wastani kwa data zote zinazopatikana kwa shamba. Mstari huu unatumika kama kigezo kukusaidia kulinganisha mavuno ya kihistoria na yaliyotabiriwa na mwelekeo wa jumla.",
    highPredictedYieldsLabel: "Mavuno ya juu yaliyotabiriwa",
    highPredictedYieldsDescription: "yanaonyesha kuwa mbinu za sasa zinafaa. Endelea na mikakati yako au iige katika maeneo mengine ya shamba lako.",
    lowPredictedYieldsLabel: "Mavuno ya chini yaliyotabiriwa",
    lowPredictedYieldsDescription: "yanaweza kuonyesha maeneo ya kuboresha, kama ratiba za kupanda, afya ya udongo, matumizi ya mbolea, umwagiliaji, udhibiti wa wadudu, msongo wa maji au upungufu wa virutubishi n.k. Chunguza na ushughulikie matatizo haya mapema ili kuepuka hasara zaidi za mavuno.",
    tipDescription: "Unaweza kuhifadhi, kupakua, au kufuta ripoti zako kwa marejeleo ya baadaye.",
    validationError: "Hitilafu ya Uthibitishaji",
    pleaseSelectCrop: "Tafadhali chagua mazao",
    pleaseEnterLatLng: "Tafadhali ingiza latitudo na longitudo au uchague nukta kwenye ramani",
    pleaseDrawGeofence: "Tafadhali chora geofence kwenye ramani au upakie faili la GeoJSON",
    invalidGeojsonFile: "Faili la GeoJSON si halali",
    invalidGeojsonFileDescription: "Tafadhali hakikisha faili lina muundo halali wa GeoJSON.",
    errorReadingFile: "Hitilafu ya kusoma faili",
    failedToReadGeojson: "Imeshindwa kusoma faili la GeoJSON. Tafadhali jaribu tena.",
    yieldReportGeneratedSuccessfully: "Ripoti ya utabiri wa mavuno imetengenezwa kwa mafanikio",
    failedToGenerateReport: "Imeshindwa kutengeneza ripoti. Tafadhali jaribu tena.",
    farmAndFarmId: "Shamba na Kitambulisho cha Shamba",
    producerName: "Jina la Mzalishaji",
    failedToLoadReport: "Imeshindwa kupakia ripoti ya utabiri wa mavuno",
    reportDataNotLoaded: "Data ya ripoti haijapakiwa. Tafadhali subiri na ujaribu tena.",
    pdfGeneratedSuccessfully: "PDF imetengenezwa kwa mafanikio",
    failedToGeneratePdf: "Imeshindwa kutengeneza PDF. Tafadhali jaribu tena.",
    editMap: "Hariri Ramani",
    editMapDescription: "Utendakazi wa kuhariri ramani utatekelezwa hapa",
    noForecastDataAvailable: "Hakuna data ya utabiri inayopatikana",
    noGraphImageAvailable: "Hakuna picha ya grafu inayopatikana",
    // Shared AI report redesign
    landSuitability: "Land Suitability",
    aiReportGuide: "AI Report Guide",
    aiReportsDashboard: "Dashibodi ya Ripoti za AI",
    aiReports: "Ripoti za AI",
    dashboardGuide: "Dashboard Guide",
    aiReportBuilders: "AI Report Builders",
    aiInsightsAndAnalytics: "AI Insights and Analytics",
    reportTypeDistribution: "Report Type Distribution",
    reportType: "Report Type",
    reportsGenerated: "Reports Generated",
    recentAiReports: "Recent AI Reports",
    vegetationVigorAnalysis: "Vegetation Vigor Analysis",
    farmProductivityAnalysis: "Farm Productivity Analysis",
    anomaliesDetection: "Anomalies Detection",
    diseaseDetection: "Disease Detection",
    averageVegetationHealth: "Average Vegetation Health",
    diseaseDetectedThisMonth: "Disease Detected this Month",
    anomaliesThisMonth: "Anomalies this Month",
    predictedYieldTrend: "Predicted Yield Trend",
    comingSoon: "Inakuja hivi karibuni",
    reportBuilderComingSoon: "This AI report builder is coming soon.",
    loadingRecentReports: "Loading recent reports…",
    noRecentAiReports: "No recent AI reports found.",
    backToDashboard: "Back to dashboard",
    reportsBreadcrumb: "Reports",
    customizeTable: "Customize table",
    customization: "Customization",
    recordsPerPage: "Records per page",
    visibleColumns: "Visible columns",
    restoreDefault: "Restore default",
    apply: "Apply",
    reportId: "Report ID",
    viewReport: "View report",
    noLandSuitabilityReportsFound: "No Land Suitability reports found.",
    confirmDeleteLandSuitabilityReport: "Are you sure you want to delete this Land Suitability report?",
    landSuitabilityReportDeletedSuccessfully: "Land Suitability report deleted successfully.",
    unableToDeleteReport: "Unable to delete the report.",
    unableToDeleteReportRetry: "Unable to delete the report. Please try again.",
    of: "of",
    estimatedComputeCost: "Estimated Compute Cost",
    totalCreditsRequired: "Total Credits Required",
    creditsAvailable: "Credits Available",
    status: "Status",
    credits: "Credits",
    creditsSufficient: "Credits Sufficient for AI Report Generation",
    insufficientCredits: "Insufficient Credits",
    selectFarm: "Select Farm",
    showAdvanced: "Show advanced",
    sourceFarmZone: "Shamba / eneo",
    sourcePolygon: "Poligoni",
    sourceCircle: "Mduara",
    sourceGeojson: "GeoJSON",
    radiusM: "Radiusi (m)",
    drawPolygon: "Chora poligoni",
    drawPolygonHelp: "Bofya ramani kuongeza nukta.",
    drawCircle: "Chora mduara",
    drawCircleHelp: "Bofya ramani kuweka kituo; weka radiusi chini au buruta mduara kubadilisha ukubwa.",
    drawingHintPoint: "Click the map to place a point. Drag the marker to adjust it.",
    drawingHintGeofence: "Click at least three locations to draw the geofence. Drag points to adjust it.",
    drawingHintPointShort: "Click the map to place or move the point",
    drawingHintGeofenceShort: "Click at least three locations to draw the farm boundary",
    undoLastGeofencePoint: "Undo last geofence point",
    undoLastPoint: "Undo last point",
    clearGeofence: "Clear geofence",
    previousImage: "Previous image",
    nextImage: "Next image",
    selectDate: "Select Date",
    reportDetails: "Report Details",
    greenAreas: "Green Areas",
    yellowAreas: "Yellow Areas",
    redAreas: "Red Areas",
    greenAreasDescription: "Current vegetation vigor outperforms historical average",
    yellowAreasDescription: "Current vegetation vigor performs according to historical average",
    redAreasDescription: "Areas with poor crop performance that require immediate attention",
    underperforming: "Underperforming",
    outperforming: "Outperforming",
    landSuitabilityDisclaimer: "This AI-generated report is intended to serve as a guide. For accurate diagnosis and tailored recommendations, consult a qualified agronomist or agricultural expert.",
    startDate: "Start Date",
    numberOfHistoricalReports: "Number of Historical Reports",
    compareReports: "Compare reports",
    satelliteImageryNote: "Satellite imagery for the exact report date may not be available. The closest available satellite layer is shown instead.",
    farmLocation: "Farm location",
    feedback: "Feedback",
    feedbackColon: "Feedback:",
    agreedWithPrediction: "Agreed with Prediction",
    predictionNotAccurate: "Prediction Not Accurate",
    attachments: "Attachments",
    noAttachmentsAdded: "No attachments added",
    doYouAgreeWithPrediction: "Do you agree with the prediction?",
    agree: "Agree",
    disagree: "Disagree",
    agreeWithPrediction: "Agree with prediction",
    disagreeWithPrediction: "Disagree with prediction",
    feedbackDisagreementPlaceholder: "Tell us what does not reflect the current reality of the field",
    addAttachments: "Add attachments",
    removeAttachment: "Remove attachment",
    submitFeedback: "Submit feedback",
    loadingFeedback: "Loading feedback",
    attachment: "Attachment",
    unableToLoadAvailableCrops: "Unable to load available crops.",
    unableToGenerateReport: "Unable to generate the report.",
    unableToLoadLandSuitabilityReport: "Unable to load the Land Suitability report.",
    unableToDownloadReport: "Unable to download the report.",
    pleaseSelectValidGeojson: "Please select a valid Polygon or MultiPolygon GeoJSON file.",
    historicalComparisonUnavailable: "Historical comparison is not available from the current report API.",
    unableToLoadFeedback: "Unable to load feedback.",
    unableToLoadReportFeedback: "Unable to load report feedback.",
    attachmentTypeSizeLimit: "Attachments must be images or videos no larger than 10 MB.",
    unableToSubmitFeedback: "Unable to submit feedback.",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully.",
    unableToSubmitFeedbackRetry: "Unable to submit feedback. Please try again.",
    openReportToViewGuide: "Open a report to view the complete AI report guide.",
    downloadReport: "Download report",
    pleaseSelectPointOnMap: "Please select a point on the map",
    pleaseDrawPolygonMinPoints: "Please draw a polygon with at least 3 points",
    // ---- Farm Productivity / Productivity Zones Analysis ----
    farmProductivity: {
      title: "Uchambuzi wa tija ya shamba",
      listOfReports: "Orodha ya ripoti",
      createNewReport: "Tengeneza ripoti mpya",
      backToDashboard: "Rudi kwenye dashibodi",
      generateReport: "Tengeneza ripoti",
      cancel: "Ghairi",
      back: "Rudi",
      deleteReport: "Futa ripoti",
      downloadReport: "Pakua ripoti",
      aiReportGuide: "Mwongozo wa ripoti ya AI",
      viewGuide: "Angalia mwongozo",
      howToUseReport: "Jinsi ya kutumia ripoti?",
      search: "Tafuta",
      reportId: "Kitambulisho cha ripoti",
      farmAndFarmId: "Shamba na kitambulisho cha shamba",
      producerName: "Jina la mtayarishaji",
      dateOfReport: "Tarehe ya ripoti",
      status: "Hali",
      statusCompleted: "Imekamilika",
      statusGenerating: "Inatengenezwa",
      statusFailed: "Imeshindikana",
      location: "Mahali",
      farm: "Shamba",
      zone: "Eneo",
      actions: "Vitendo",
      view: "Tazama",
      delete: "Futa",
      selectFarmGeofence: "Chagua geofence ya shamba",
      selectFarmGeofenceHelp: "Chagua shamba lililosajiliwa, chora mpaka kwenye ramani, au pakia faili ya GeoJSON.",
      selectFarmZone: "Chagua shamba / eneo",
      sourceFarmZone: "Shamba / eneo",
      sourcePolygon: "Poligoni",
      sourceCircle: "Mduara",
      sourceGeojson: "GeoJSON",
      radiusM: "Radiusi (m)",
      select: "Chagua",
      uploadGeojsonFile: "Pakia faili ya GeoJSON",
      uploadGeojsonHelp: "Chagua faili ya GeoJSON yenye geofence kutoka kwenye kompyuta yako na uipakie. Geofence moja tu itapakiwa kwa wakati mmoja, hata kama faili ina nyingi.",
      selectAFile: "Chagua faili",
      drawPolygon: "Chora poligoni",
      drawPolygonHelp: "Bofya ramani kuongeza nukta.",
      drawCircle: "Chora mduara",
      drawCircleHelp: "Bofya ramani kuweka kituo; weka radiusi chini au buruta mduara kubadilisha ukubwa.",
      estimatedComputeCost: "Gharama inayokadiriwa ya kompyuta",
      totalCreditsRequired: "Jumla ya krediti zinazohitajika",
      creditsComingSoon: "Mfumo wa krediti unakuja hivi karibuni.",
      reportDetails: "Maelezo ya ripoti",
      generating: "Inatengeneza ripoti...",
      generatingHelp: "Ripoti yako inatengenezwa. Hii inaweza kuchukua dakika chache.",
      failed: "Utengenezaji wa ripoti umeshindikana.",
      reportDescription: "Ripoti ya maeneo ya tija inachambua tija ya eneo la shamba lako kulingana na utendaji wa kihistoria na viashiria vya mimea.",
      disclaimerTitle: "KANUSHO",
      disclaimer: "Ripoti hii iliyotengenezwa na AI inakusudiwa kuwa mwongozo. Kwa utambuzi sahihi na mapendekezo maalum, tunashauri sana kushauriana na mtaalamu wa kilimo aliyestahili.",
      zoneLabels: {
        "Lowest Productivity Zones": "Maeneo yenye tija ya chini zaidi",
        "Low Productivity Zones": "Maeneo yenye tija ya chini",
        "Moderate Productivity Zones": "Maeneo yenye tija ya wastani",
        "High Productivity Zones": "Maeneo yenye tija ya juu",
        "Highest Productivity Zones": "Maeneo yenye tija ya juu zaidi",
      },
      zoneDesc: {
        "Lowest Productivity Zones": "Maeneo yenye utendaji duni zaidi wa mazao yanayohitaji uangalizi au hatua za haraka.",
        "Low Productivity Zones": "Maeneo yenye utendaji wa chini ya wastani yanayohitaji maboresho.",
        "Moderate Productivity Zones": "Maeneo yenye utendaji wa wastani ambayo yanaweza kuhitaji marekebisho.",
        "High Productivity Zones": "Maeneo yenye utendaji wa juu ya wastani na uwezo mzuri wa mavuno.",
        "Highest Productivity Zones": "Maeneo yenye utendaji bora na uwezo mkubwa zaidi wa mavuno.",
      },
      feedback: "Maoni",
      doYouAgree: "Je, unakubaliana na utabiri?",
      agree: "Kubali",
      disagree: "Kataa",
      agreedWithPrediction: "Umekubaliana na utabiri",
      disagreedWithPrediction: "Hukubaliani na utabiri",
      disagreeHelp: "Ikiwa hukubaliani na matokeo haya, toa maoni yako",
      addFeedback: "Ongeza maoni",
      feedbackPlaceholder: "Ingiza hapa",
      attachmentsOptional: "Viambatisho (hiari)",
      attachments: "Viambatisho",
      download: "Pakua",
      attachmentsHelp: "Buruta na udondoshe picha au video hapa, au vinjari faili. Miundo inayoungwa mkono: JPG, PNG, MP4.",
      selectFilesToUpload: "Chagua faili za kupakia data",
      orDragAndDrop: "au buruta na udondoshe hapa",
      submit: "Wasilisha",
      feedbackSubmitted: "Maoni yamewasilishwa kwa mafanikio.",
      feedbackAlreadySubmitted: "Maoni tayari yamewasilishwa kwa ripoti hii.",
      guideTitle: "Mwongozo wa maeneo ya tija",
      guideStep: "Hatua {current} ya {total}",
      next: "Ifuatayo",
      close: "Funga",
      guideStep1Title: "Ripoti ya maeneo ya tija ni nini?",
      guideStep1Body: "Ripoti ya maeneo ya tija inachambua tija ya maeneo ndani ya eneo au shamba lako na kuyagawanya katika maeneo ya mazao ya chini, wastani na juu.",
      guideStep2Title: "Jinsi ya kutengeneza ripoti?",
      guideStep2Body: "Kutengeneza ripoti ni rahisi:\n\n1. Chagua shamba kutoka menyu (ikiwa limesajiliwa) au chora/pakia mpaka.\n2. Tengeneza ripoti na subiri uchambuzi ukamilike.",
      guideStep3Title: "Jinsi ya kufasiri ripoti?",
      guideStep3Body: "Baada ya kutengenezwa, ripoti inaonyesha ramani yenye rangi inayogawanya shamba lako katika maeneo matatu ya tija.",
      guideTip: "Kidokezo:",
      guideTipBody: "Anza na maeneo ya rangi ya chungwa — yanahitaji maboresho ya haraka zaidi. Jifunze maeneo ya kijani ili kuiga mbinu nzuri.",
      invalidGeojsonFile: "Faili ya GeoJSON si sahihi",
      invalidGeojsonFileDescription: "Faili iliyochaguliwa si GeoJSON sahihi. Angalia na ujaribu tena.",
      generateFailed: "Haikuweza kuanza utengenezaji wa ripoti. Tafadhali jaribu tena.",
      loadFailed: "Haikuweza kupakia ripoti. Tafadhali jaribu tena.",
      deleteConfirmTitle: "Futa ripoti",
      deleteConfirmMessage: "Una uhakika unataka kufuta ripoti hii? Kitendo hiki hakiwezi kutenduliwa.",
      deleted: "Ripoti imefutwa kwa mafanikio.",
      uploadFailed: "Upakiaji wa faili umeshindikana. Tafadhali jaribu tena.",
    },

    // ---- Anomaly Detection ----
    anomalyDetection: {
      title: "Ugunduzi wa anomali",
      reportComparison: "Ulinganisho wa ripoti",
      listOfReports: "Orodha ya ripoti",
      createNewReport: "Tengeneza ripoti mpya",
      backToDashboard: "Rudi kwenye dashibodi",
      generateReport: "Tengeneza ripoti",
      cancel: "Ghairi",
      back: "Rudi",
      deleteReport: "Futa ripoti",
      downloadReport: "Pakua ripoti",
      compareReports: "Linganisha ripoti",
      aiReportGuide: "Mwongozo wa ripoti ya AI",
      search: "Tafuta",
      reportId: "Kitambulisho cha ripoti",
      farmAndFarmId: "Shamba na kitambulisho cha shamba",
      producerName: "Jina la mtayarishaji",
      dateOfReport: "Tarehe ya ripoti",
      status: "Hali",
      statusCompleted: "Imekamilika",
      statusGenerating: "Inatengenezwa",
      statusPartial: "Sehemu",
      statusFailed: "Imeshindikana",
      location: "Mahali",
      farm: "Shamba",
      zone: "Eneo",
      actions: "Vitendo",
      view: "Tazama",
      delete: "Futa",
      selectFarmGeofence: "Chagua geofence ya shamba",
      selectFarmGeofenceHelp: "Chagua shamba lililosajiliwa, chora mpaka kwenye ramani, au pakia faili ya GeoJSON.",
      selectFarmZone: "Chagua shamba / eneo",
      sourceFarmZone: "Shamba / eneo",
      sourcePolygon: "Poligoni",
      sourceCircle: "Mduara",
      sourceGeojson: "GeoJSON",
      radiusM: "Radiusi (m)",
      select: "Chagua",
      uploadGeojsonFile: "Pakia faili ya GeoJSON",
      uploadGeojsonHelp: "Chagua faili ya GeoJSON yenye geofence kutoka kwenye kompyuta yako na uipakie. Geofence moja tu itapakiwa kwa wakati mmoja, hata kama faili ina nyingi.",
      selectAFile: "Chagua faili",
      drawPolygon: "Chora poligoni",
      drawPolygonHelp: "Bofya ramani kuongeza nukta.",
      drawCircle: "Chora mduara",
      drawCircleHelp: "Bofya ramani kuweka kituo; weka radiusi chini au buruta mduara kubadilisha ukubwa.",
      detectAnomalies: "Gundua anomali",
      detectAnomaliesHelp: "Baada ya kuchora au kupakia geofence, chagua tarehe inayohitajika ili kugundua anomali.",
      startDate: "Tarehe ya kuanza",
      fetchingDates: "Inatafuta tarehe zinazopatikana...",
      noAvailableDates: "Hakuna tarehe za satelaiti zinazopatikana kwa eneo hili.",
      selectDateToGenerate: "Chagua tarehe inayopatikana, kisha tengeneza ripoti.",
      numberOfHistoricalReports: "Idadi ya ripoti za kihistoria",
      historicalReportsPlaceholder: "Andika hapa",
      historicalReportsNote: "Kuongeza idadi hii kutatumia krediti za AI za ziada kwa kila picha ya kihistoria inayohitajika.",
      estimatedComputeCost: "Gharama inayokadiriwa ya kompyuta",
      totalCreditsRequired: "Jumla ya krediti zinazohitajika",
      creditsComingSoon: "Mfumo wa krediti unakuja hivi karibuni.",
      selectDate: "Chagua tarehe",
      reportDetails: "Maelezo ya ripoti",
      closestImageNote: "Picha za satelaiti za {requested} hazikupatikana. Tumetumia picha iliyo karibu zaidi.",
      generating: "Inatengeneza ripoti...",
      generatingHelp: "Ripoti yako inatengenezwa. Hii inaweza kuchukua dakika chache.",
      partialWarning: "Baadhi ya tarehe hazikuweza kutengenezwa kwa ripoti hii.",
      failed: "Utengenezaji wa ripoti umeshindikana.",
      disclaimerTitle: "KANUSHO",
      disclaimer: "Ripoti hii iliyotengenezwa na AI inakusudiwa kuwa mwongozo. Kwa utambuzi sahihi na mapendekezo maalum, tunashauri sana kushauriana na mtaalamu wa kilimo aliyestahili.",
      greenAreas: "Maeneo ya kijani",
      greenAreasDesc: "Nguvu ya mimea ya sasa inazidi wastani wa kihistoria",
      yellowAreas: "Maeneo ya manjano",
      yellowAreasDesc: "Nguvu ya mimea ya sasa inafanya kazi kulingana na wastani wa kihistoria",
      redAreas: "Maeneo mekundu",
      redAreasDesc: "Maeneo yenye utendaji duni wa mazao yanayohitaji uangalizi au hatua za haraka.",
      underperforming: "Chini ya utendaji",
      outperforming: "Juu ya utendaji",
      imageComparison: "Ulinganisho wa ripoti",
      sideComparison: "Ulinganisho wa pembeni",
      sliderComparison: "Ulinganisho wa slide",
      transparencyComparison: "Ulinganisho wa uwazi",
      transparencySlider: "Kidhibiti cha uwazi",
      notGeneratedPrompt: "Ripoti hii bado haijatengenezwa kwa tarehe iliyochaguliwa. Itengenezwe sasa?",
      generateNow: "Tengeneza sasa",
      feedback: "Maoni",
      doYouAgree: "Je, unakubaliana na utabiri?",
      agree: "Kubali",
      disagree: "Kataa",
      agreedWithPrediction: "Umekubaliana na utabiri",
      disagreedWithPrediction: "Hukubaliani na utabiri",
      disagreeHelp: "Ikiwa hukubaliani na matokeo haya, toa maoni yako",
      addFeedback: "Ongeza maoni",
      feedbackPlaceholder: "Ingiza hapa",
      attachmentsOptional: "Viambatisho (hiari)",
      attachments: "Viambatisho",
      download: "Pakua",
      attachmentsHelp: "Buruta na udondoshe picha au video hapa, au vinjari faili. Miundo inayoungwa mkono: JPG, PNG, MP4.",
      selectFilesToUpload: "Chagua faili za kupakia data",
      orDragAndDrop: "au buruta na udondoshe hapa",
      submit: "Wasilisha",
      feedbackSubmitted: "Maoni yamewasilishwa kwa mafanikio.",
      feedbackAlreadySubmitted: "Maoni tayari yamewasilishwa kwa ripoti hii.",
      guideTitle: "Mwongozo wa ugunduzi wa anomali",
      guideStep: "Hatua {current} ya {total}",
      next: "Ifuatayo",
      close: "Funga",
      guideStep1Title: "Ugunduzi wa anomali ni nini?",
      guideStep1Body: "Ugunduzi wa anomali unalinganisha utendaji wa mimea wa sasa na wastani wa kihistoria ili kubaini maeneo yanayofanya vizuri au vibaya kuliko inavyotarajiwa.",
      guideStep2Title: "Jinsi ya kutengeneza ripoti?",
      guideStep2Body: "Kutengeneza ripoti ni rahisi:\n\n1. Chagua shamba kutoka menyu (ikiwa limesajiliwa) au chora/pakia mpaka.\n2. Chagua tarehe inayopatikana na tengeneza ripoti.",
      guideStep3Title: "Jinsi ya kufasiri ripoti?",
      guideStep3Body: "Baada ya kutengenezwa, ripoti inaonyesha ramani ya joto yenye rangi kulingana na ulinganisho wa nguvu ya mimea ya sasa na historia.",
      guideTip: "Kidokezo:",
      guideTipBody: "Ulinganisho wa tarehe: ripoti hutoa ramani za joto kwa tarehe nyingi ili ufuatilie mabadiliko kwa muda.",
      invalidGeojsonFile: "Faili ya GeoJSON si sahihi",
      invalidGeojsonFileDescription: "Faili iliyochaguliwa si GeoJSON sahihi. Angalia na ujaribu tena.",
      geofenceRequired: "Chagua shamba/eneo, chora geofence, au pakia GeoJSON.",
      dateRequired: "Chagua tarehe inayopatikana.",
      generateFailed: "Haikuweza kuanza utengenezaji wa ripoti. Tafadhali jaribu tena.",
      loadFailed: "Haikuweza kupakia ripoti. Tafadhali jaribu tena.",
      datesFailed: "Imeshindikana kupata tarehe zinazopatikana. Jaribu tena.",
      deleteConfirmTitle: "Futa ripoti",
      deleteConfirmMessage: "Una uhakika unataka kufuta ripoti hii? Kitendo hiki hakiwezi kutenduliwa.",
      deleted: "Ripoti imefutwa kwa mafanikio.",
      uploadFailed: "Upakiaji wa faili umeshindikana. Tafadhali jaribu tena.",
    },

        yieldPredictionDesign: {
      disclaimerTitle: "KANUSHO",
      disclaimerIntro: "In our yield predictions, the uncertainty may be 100% because there are many factors that are beyond our control, including:",
      disclaimer1: "It is impossible to accurately predict the weather for a whole season, so in some cases farmers could lose all their harvest due to just one hail event or flooding (especially now that global warming is often causing all these irregularities).",
      disclaimer2: "Yields are highly dependent on the management practices of farmers. For example, if they fail to spray pesticides at the right time, or irrigate properly, then yields will be very different from the predictions - this is also beyond our control.",
      disclaimer3: "There are many other factors like the above that may contribute to significant errors in the AI yield predictions.",
      disclaimer4: "If the farmer provides historical yields (ADVANCED mode), then predictions tend to be more accurate than the default (non-ADVANCED mode) predictions.",
      // feedback (shared FeedbackDisplay / FeedbackDialog)

      feedback: "Maoni",
      doYouAgree: "Je, unakubaliana na utabiri?",
      agree: "Kubali",
      disagree: "Kataa",
      agreedWithPrediction: "Umekubaliana na utabiri",
      disagreedWithPrediction: "Hukubaliani na utabiri",
      disagreeHelp: "Ikiwa hukubaliani na matokeo haya, toa maoni yako",
      addFeedback: "Ongeza maoni",
      feedbackPlaceholder: "Ingiza hapa",
      attachmentsOptional: "Viambatisho (hiari)",
      attachments: "Viambatisho",
      download: "Pakua",
      attachmentsHelp: "Buruta na udondoshe picha au video hapa, au vinjari faili. Miundo inayoungwa mkono: JPG, PNG, MP4.",
      selectFilesToUpload: "Chagua faili za kupakia data",
      orDragAndDrop: "au buruta na udondoshe hapa",
      submit: "Wasilisha",
      feedbackSubmitted: "Maoni yamewasilishwa kwa mafanikio.",
      feedbackAlreadySubmitted: "Maoni tayari yamewasilishwa kwa ripoti hii.",
      uploadFailed: "Upakiaji wa faili umeshindikana. Tafadhali jaribu tena.",
    },

landSuitabilityDesign: {
      reportDetails: "Maelezo ya ripoti",
      greenAreas: "Maeneo ya kijani",
      greenAreasDesc: "Maeneo yaliyokadiriwa kuwa yanafaa sana kwa zao lililochaguliwa",
      yellowAreas: "Maeneo ya manjano",
      yellowAreasDesc: "Maeneo yenye ufaafu wa wastani ambayo yanaweza kuhitaji uangalizi",
      redAreas: "Maeneo mekundu",
      redAreasDesc: "Maeneo yaliyokadiriwa kuwa hayafai na yanaweza kuhitaji hatua",
      underperforming: "Chini ya utendaji",
      outperforming: "Juu ya utendaji",
      feedback: "Maoni",
      doYouAgree: "Je, unakubaliana na utabiri?",
      agree: "Kubali",
      disagree: "Kataa",
      agreedWithPrediction: "Umekubaliana na utabiri",
      disagreedWithPrediction: "Hukubaliani na utabiri",
      disagreeHelp: "Ikiwa hukubaliani na matokeo haya, toa maoni yako",
      addFeedback: "Ongeza maoni",
      feedbackPlaceholder: "Ingiza hapa",
      attachmentsOptional: "Viambatisho (hiari)",
      attachments: "Viambatisho",
      download: "Pakua",
      attachmentsHelp: "Buruta na udondoshe picha au video hapa, au vinjari faili. Miundo inayoungwa mkono: JPG, PNG, MP4.",
      selectFilesToUpload: "Chagua faili za kupakia data",
      orDragAndDrop: "au buruta na udondoshe hapa",
      submit: "Wasilisha",
      feedbackSubmitted: "Maoni yamewasilishwa kwa mafanikio.",
      feedbackAlreadySubmitted: "Maoni tayari yamewasilishwa kwa ripoti hii.",
      uploadFailed: "Upakiaji wa faili umeshindikana. Tafadhali jaribu tena.",
    },
    cropProgression: {
      title: "Uchambuzi wa nguvu ya mimea",
      listOfReports: "Orodha ya ripoti",
      createNewReport: "Tengeneza ripoti mpya",
      backToDashboard: "Rudi kwenye dashibodi",
      generateReport: "Tengeneza ripoti",
      cancel: "Ghairi",
      back: "Rudi",
      deleteReport: "Futa ripoti",
      downloadReport: "Pakua ripoti",
      compareImages: "Linganisha picha",
      aiReportGuide: "Mwongozo wa ripoti ya AI",
      search: "Tafuta",
      reportId: "Kitambulisho cha ripoti",
      farmAndFarmId: "Shamba na kitambulisho cha shamba",
      producerName: "Jina la mtayarishaji",
      dateOfReport: "Tarehe ya ripoti",
      selectedDate: "Tarehe ya ripoti",
      status: "Hali",
      statusCompleted: "Imekamilika",
      statusGenerating: "Inatengenezwa",
      statusPartial: "Sehemu",
      statusFailed: "Imeshindikana",
      location: "Mahali",
      farm: "Shamba",
      zone: "Eneo",
      actions: "Vitendo",
      view: "Tazama",
      delete: "Futa",
      selectFarmGeofence: "Chagua geofence ya shamba",
      selectFarmGeofenceHelp: "Chagua shamba lililosajiliwa, chora mpaka kwenye ramani, au pakia GeoJSON ili kuanza kuchambua eneo lako.",
      point: "Nukta",
      geofence: "Geofence",
      selectFarmZone: "Chagua shamba / eneo",
      sourceFarmZone: "Shamba / eneo",
      sourcePolygon: "Poligoni",
      sourceCircle: "Mduara",
      sourceGeojson: "GeoJSON",
      mapView: "Mwonekano wa ramani",
      latitude: "Latitudo",
      longitude: "Longitudo",
      radiusKm: "Radiusi (km)",
      radiusM: "Radiusi (m)",
      enterHere: "Ingiza hapa",
      select: "Chagua",
      uploadGeojsonFile: "Pakia faili ya GeoJSON",
      uploadGeojsonHelp: "Chagua faili ya GeoJSON yenye geofence kutoka kwenye kompyuta yako na uipakie. Geofence moja tu itapakiwa kwa wakati mmoja, hata kama faili ina nyingi.",
      selectAFile: "Chagua faili",
      drawPolygon: "Chora poligoni",
      drawPolygonHelp: "Bofya ramani kuongeza nukta.",
      drawCircle: "Chora mduara",
      drawCircleHelp: "Bofya ramani kuweka kituo; weka radiusi chini au buruta mduara kubadilisha ukubwa.",
      clearDrawing: "Futa",
      searchLocation: "Tafuta mahali",
      closePolygonHint: "Bofya nukta ya kwanza kufunga eneo",
      unnamedFarm: "Shamba #{id}",
      unnamedZone: "Eneo #{id}",
      selectDate: "Chagua tarehe",
      availableDates: "Tarehe zinazopatikana",
      fetchingDates: "Inatafuta tarehe zinazopatikana...",
      noAvailableDates: "Hakuna tarehe za satelaiti zinazopatikana kwa eneo hili.",
      selectDateToGenerate: "Chagua tarehe inayopatikana, kisha tengeneza ripoti.",
      estimatedComputeCost: "Gharama inayokadiriwa ya kompyuta",
      totalCreditsRequired: "Jumla ya mikopo inayohitajika",
      creditsAvailable: "Mikopo inayopatikana",
      creditsSufficient: "Mikopo ya kutosha kwa utengenezaji wa ripoti ya AI",
      reportType: "Aina ya ripoti",
      selectReportType: "Chagua aina ya ripoti",
      chooseIndexHelp: "Chagua faharasa ya satelaiti kuchambua ukuaji, unyevu, au virutubisho vya zao kwa muda.",
      scale: "Kipimo",
      generating: "Inatengeneza ripoti...",
      generatingHelp: "Ripoti yako inatengenezwa. Hii inaweza kuchukua dakika chache.",
      partialWarning: "Baadhi ya faharasa hazikuweza kutengenezwa kwa tarehe hii.",
      failed: "Utengenezaji wa ripoti umeshindikana.",
      valuesCloseToOne: "Thamani karibu na 1 zinaonyesha mimea yenye afya zaidi",
      disclaimerTitle: "KANUSHO",
      disclaimer: "Ripoti hii iliyotengenezwa na AI inakusudiwa kuwa mwongozo. Kwa utambuzi sahihi na mapendekezo maalum, tunashauri sana kushauriana na mtaalamu wa kilimo aliyestahili.",
      indexNDVI: "Afya ya zao (NDVI)",
      indexMSAVI: "Ukuaji wa mimea wa awali (MSAVI)",
      indexLSWI: "Kiwango cha unyevu (LSWI)",
      indexRECI: "Makadirio ya kiwango cha virutubisho (RECI)",
      indexNDRE: "Ukijani na msongamano wa dari ya majani (NDRE)",
      reportComparison: "Ulinganisho wa ripoti za nguvu ya mimea",
      imageComparison: "Ulinganisho wa picha",
      sideComparison: "Ulinganisho wa pembeni",
      sliderComparison: "Ulinganisho wa kitelezi",
      transparencyComparison: "Ulinganisho wa uwazi",
      transparencySlider: "Kitelezi cha uwazi",
      notGeneratedPrompt: "Ripoti hii bado haijatengenezwa kwa tarehe iliyochaguliwa. Itengenezwe sasa?",
      generateNow: "Tengeneza sasa",
      feedback: "Maoni",
      doYouAgree: "Je, unakubaliana na utabiri?",
      agree: "Kubali",
      disagree: "Kataa",
      agreedWithPrediction: "Amekubaliana na utabiri",
      disagreedWithPrediction: "Amekataa utabiri",
      disagreeHelp: "Ikiwa hukubaliani na matokeo haya, toa maoni yako",
      addFeedback: "Ongeza maoni",
      feedbackPlaceholder: "Ingiza hapa",
      attachmentsOptional: "Viambatisho (hiari)",
      attachments: "Viambatisho",
      download: "Pakua",
      attachmentsHelp: "Buruta na udondoshe picha au video hapa, au vinjari faili. Miundo inayoungwa mkono: JPG, PNG, MP4.",
      selectFilesToUpload: "Chagua faili za kupakia data",
      orDragAndDrop: "au buruta na udondoshe hapa",
      submit: "Wasilisha",
      feedbackSubmitted: "Maoni yamewasilishwa kwa mafanikio.",
      feedbackAlreadySubmitted: "Maoni tayari yamewasilishwa kwa ripoti hii.",
      guideTitle: "Mwongozo wa uchambuzi wa nguvu ya mimea",
      guideStep: "Hatua {current} ya {total}",
      next: "Ifuatayo",
      close: "Funga",
      guideStep1Title: "Ripoti ya uchambuzi wa nguvu ya mimea ni nini?",
      guideStep1Body: "Uchambuzi huu unakusaidia kutambua maeneo ya shamba yenye nguvu ya mimea ya chini ili uchukue hatua kwa wakati. Ripoti hutumia picha za satelaiti kuonyesha afya ya mazao kwa wakati maalum.\n\nRamani ya joto inaonyesha sehemu za shamba zinazoweza kuhitaji umakini. Kwa kulinganisha picha za tarehe tofauti, unaweza kufuatilia kama mazao yanaboresha au yanazorota.",
      guideStep2Title: "Jinsi ya kutengeneza ripoti?",
      guideStep2Body: "Kutengeneza ripoti ni rahisi:\n\n1. Chagua shamba kutoka kwenye menyu (ikiwa limesajiliwa). Mpaka utaonekana kwenye ramani. Au chora mpaka mwenyewe ikiwa bado haujasajiliwa.\n2. Chagua tarehe: tarehe unayotaka kuona data za nguvu.\n3. Bofya \"Tengeneza ripoti\" kuona uchambuzi.",
      guideStep3Title: "Jinsi ya kufasiri ripoti?",
      guideStep3Body: "Baada ya kutengenezwa, utaona ramani ya joto ya shamba yenye rangi ya kijani, manjano, na nyekundu.\n\nKijani = Nguvu ya juu ya mimea\nManjano/Nyekundu = Nguvu ya chini → inaweza kuhitaji umakini\n\nNguvu ya chini inaweza kusababishwa na mavuno, udongo duni, wadudu, au hali ya hewa ya hivi karibuni.",
      guideTip: "Kidokezo:",
      guideTipBody: "Tumia kibadilishaji cha tarehe chini ya ramani ya joto kuona ripoti nyingi na kufuatilia mabadiliko ya afya ya mazao. Unaweza kuhifadhi, kupakua, au kufuta ripoti wakati wowote.",
      additionalReportTypes: "Aina za ripoti za ziada zinazopatikana:",
      invalidGeojsonFile: "Faili ya GeoJSON si sahihi",
      invalidGeojsonFileDescription: "Faili iliyochaguliwa si GeoJSON sahihi. Angalia na ujaribu tena.",
      geofenceRequired: "Chagua shamba/eneo, chora geofence, au pakia GeoJSON.",
      dateRequired: "Chagua tarehe inayopatikana.",
      generateFailed: "Haikuweza kuanza utengenezaji wa ripoti. Tafadhali jaribu tena.",
      loadFailed: "Haikuweza kupakia ripoti. Tafadhali jaribu tena.",
      datesFailed: "Haikuweza kupata tarehe zinazopatikana. Tafadhali jaribu tena.",
      deleteConfirmTitle: "Futa ripoti",
      deleteConfirmMessage: "Una uhakika unataka kufuta ripoti hii? Kitendo hiki hakiwezi kutenduliwa.",
      deleted: "Ripoti imefutwa kwa mafanikio.",
      uploadFailed: "Upakiaji wa faili umeshindikana. Tafadhali jaribu tena.",
    },
    aiClient: {
      credits: "Mikopo",
      cancel: "Ghairi",
      save: "Hifadhi",
      back: "Rudi",
      close: "Funga",
      search: "Tafuta",
      makeSelection: "Chagua chaguo",
      errorTitle: "Hitilafu",
      successTitle: "Imefanikiwa",
      loadFailed: "Haikuweza kupakia data. Tafadhali jaribu tena.",
      saveFailed: "Haikuweza kuhifadhi. Tafadhali jaribu tena.",
      saved: "Mipangilio imehifadhiwa kwa mafanikio.",
      rt_vegetation_vigor: "Nguvu ya mimea",
      rt_farm_productivity: "Tija ya shamba",
      rt_anomaly_detection: "Ugunduzi wa anomalia",
      rt_yield_prediction: "Utabiri wa mavuno",
      rt_disease_detection: "Ugunduzi wa magonjwa",
      rt_land_suitability: "Ufaafu wa ardhi",
      dashTitle: "Dashibodi ya ripoti za AI",
      dashGuide: "Mwongozo wa dashibodi",
      builders: "Vijenzi vya ripoti za AI",
      distributionTitle: "Usambazaji kwa aina ya ripoti",
      colReportType: "Aina ya ripoti",
      colReportsGenerated: "Ripoti zilizotengenezwa",
      recentTitle: "Ripoti za AI za hivi karibuni",
      noRecent: "Hakuna ripoti zilizotengenezwa bado.",
      noDistribution: "Hakuna shughuli ya ripoti bado.",
      na: "N/A",
      bVegetationVigor: "Uchambuzi wa nguvu ya mimea",
      bFarmProductivity: "Uchambuzi wa tija ya shamba",
      bAnomalies: "Ugunduzi wa anomalia",
      bYield: "Utabiri wa mavuno",
      bDisease: "Ugunduzi wa magonjwa",
      bLand: "Ufaafu wa ardhi",
      insightsTitle: "Maarifa na uchambuzi wa AI",
      iVegHealth: "Afya wastani ya mimea",
      iDisease: "Magonjwa yaliyogunduliwa mwezi huu",
      iAnomalies: "Anomalia mwezi huu",
      iYieldTrend: "Mwenendo wa mavuno yaliyotabiriwa",
      creditsAvailableLabel: "Inapatikana",
      totalCredits: "Jumla ya mikopo:",
      creditsUsedLabel: "Mikopo iliyotumika:",
      topUp: "Ongeza mikopo",
      topUpInfo: "Wasiliana na msimamizi wako ili kuongeza mikopo.",
      creditsHistory: "Historia ya mikopo",
      manageBtn: "Dhibiti ripoti za AI na mikopo",
      manageTitle: "Dhibiti ripoti za AI na mikopo",
      usageLogBtn: "Kumbukumbu ya matumizi ya mikopo",
      cardAvailable: "Mikopo inayopatikana",
      cardTotal: "Jumla ya mikopo",
      cardUsed: "Mikopo iliyotumika",
      refreshesOn: "Inasasishwa tarehe",
      assignedOn: "Iligawiwa tarehe",
      distBudgetTitle: "Usambazaji na bajeti ya ripoti za AI",
      distBudgetHelp: "Sanidi ufikiaji wa ripoti za AI kwa vyama, viwanda na wakulima wako. Gawanya bajeti mahususi za mikopo kwa kila ngazi ili kudhibiti matumizi ya rasilimali za ushirika kwa ufanisi.",
      group_cooperative: "Ushirika",
      group_buying_station: "Kituo cha ununuzi",
      group_farmer: "Mkulima",
      monthlyCredits: "Mikopo ya kila mwezi",
      aiReports: "Ripoti za AI",
      enabled: "Imewashwa",
      disabled: "Imezimwa",
      overAllocation: "Ugawaji wa kikundi unazidi bajeti ya mikopo ya ushirika.",
      usageLogTitle: "Kumbukumbu ya matumizi ya mikopo",
      filterCooperative: "Ushirika",
      filterReport: "Ripoti ya AI",
      colDateTime: "Tarehe na saa",
      colEntity: "Chombo",
      colAiReport: "Ripoti ya AI",
      colCreditsUsed: "Mikopo iliyotumika",
      colBalance: "Salio",
      historyTitle: "Historia ya mikopo",
      historyDesc: "Muhtasari wa ugawaji wa mikopo dhidi ya matumizi kwa ushirika huu. Tumia muhtasari huu kufuatilia mienendo ya matumizi ya kila mwezi na mizunguko ya bili.",
      coopLabel: "Ushirika",
      colMonth: "Mwezi",
      colCreditsAssigned: "Mikopo iliyogawiwa",
      colClosingBalance: "Salio la kufunga",
      noHistory: "Hakuna historia ya mikopo bado.",
      guideTitle: "Mwongozo wa dashibodi ya ripoti za AI za Dimitra",
      guideStep: "Hatua",
      guideOf: "ya",
      guideClose: "Funga",
      guideSkip: "Ruka",
      guideNext: "Ifuatayo",
      guideBack: "Rudi",
      guideDone: "Funga",
      g1Title: "Muhtasari wa dashibodi",
      g1Intro: "Karibu kwenye kituo chako cha maarifa ya AI. Mwongozo huu utakusaidia kufasiri ramani, kudhibiti mikopo yako, na kutumia modeli za AI.",
      g1Points: [
        "Elewa maarifa ya ramani: Tumia vichujio kwenye ramani kuona mikoa na maeneo mahususi. Ramani ya joto inatoa mwonekano wa haraka wa rangi wa utendaji wa mashamba katika ushirika, na funguo za viashiria vya Juu/Wastani/Chini.",
        "Fuatilia mikopo: Mikopo yako inayopatikana sasa inaonyeshwa juu kulia. Hakikisha una salio la kutosha kabla ya kutengeneza ripoti kubwa.",
      ],
      g2Title: "Kuelewa ripoti za AI",
      g2Intro: "Dashibodi yako inatoa ufikiaji wa modeli maalum za AI. Kila ripoti inachambua vipengele tofauti vya data yako ya kilimo.",
      g2Points: [
        "Nguvu ya mimea: Tathmini afya ya jumla ya mazao na tambua maeneo yanayohitaji umakini.",
        "Tija ya shamba: Chambua mienendo ya kihistoria ya tija ili kuboresha uwezo wa mavuno.",
        "Ugunduzi wa anomalia: Gundua mifumo isiyo ya kawaida shambani inayoweza kuonyesha msongo au vitisho vya nje.",
        "Utabiri wa mavuno: Tabiri matokeo ya mavuno kulingana na data ya ukuaji wa sasa.",
        "Ugunduzi wa magonjwa: Tumia picha za mimea kutambua magonjwa mahususi mara moja.",
      ],
      g3Title: "Jinsi mikopo inavyofanya kazi",
      g3Intro: "Dimitra hutumia mfumo unaotegemea mikopo kudhibiti matumizi ya rasilimali za AI. Mikopo hutumika kama sarafu ya kutengeneza ripoti.",
      g3Points: [
        "Ugawaji: Ushirika wako unapewa salio la kila mwezi na Msimamizi.",
        "Matumizi: Kila unapotengeneza ripoti, mikopo hukatwa kutoka kwenye salio lako linalopatikana.",
        "Uwazi: Unaweza kufuatilia kila punguzo katika daftari lako maalum la mikopo.",
      ],
      g4Title: "Ufuatiliaji wa matumizi na historia ya mikopo",
      g4Intro: "Dumisha udhibiti wa bajeti yako kwa kufuatilia kwa karibu historia ya mikopo.",
      g4Points: [
        "Salio linalopatikana: Huonekana daima kwenye kadi ya juu kulia. Zingatia tarehe ya usasishaji ili kujua lini ugawaji unaofuata utafika.",
        "Kumbukumbu ya matumizi: Bofya [Historia ya mikopo] kuona maelezo ya ripoti gani ilitengenezwa, lini, na na chombo gani (ushirika, muungano, kiwanda, au mkulima).",
        "Usimamizi: Ikiwa mikopo inaisha, tumia kitufe cha [Dhibiti ripoti za AI na mikopo] kurekebisha bajeti za ngazi ya chombo au wasiliana na msimamizi kwa ongezeko la ziada.",
      ],
    },
  },
};
